<template>
  <v-container style="max-width: 100%">
    <v-card
      flat
      class="d-flex align-center justify-center py-4 mb-4"
    >
      <v-btn
        icon
        @click="prevMonth"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-btn
        small
        class="mr-2"
        :disabled="currentMonthOffset === 0"
        @click="goToday"
      >
        This month
      </v-btn>

      <strong 
        :class="{ 'green--text': currentMonthOffset === 0 }"
        style="font-size: 16px;"
      >
        {{ monthRange.label }}
      </strong>

      <v-btn
        icon
        @click="nextMonth"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <!-- Months Segmented Control -->
      <v-btn-toggle
        v-model="monthsBack"
        dense
        mandatory
        class="months-toggle ml-4"
      >
        <v-btn
          small
          :value="6"
        >
          6M
        </v-btn>
        <v-btn
          small
          :value="12"
        >
          12M
        </v-btn>
        <v-btn
          small
          :value="24"
        >
          24M
        </v-btn>
        <v-btn
          small
          :value="60"
        >
          60M
        </v-btn>
      </v-btn-toggle>
    </v-card>

    <v-tabs
      v-model="tab"
      grow
    >
      <v-tab
        v-for="(itemTab, index) in itemsTab"
        :key="itemTab"
      >
        <span class="ppc_darkgreen--text">
          {{ itemTab }}

          <!-- clients -->
          <v-chip 
            v-if="index === 0"
            small 
            class="ml-2" 
            color="grey lighten-2"
          >
            {{ summary.converted.total }} 
            <span class="ml-1">
              ({{ summary.converted.direct }}/{{ summary.converted.agency }})
            </span>
            <!-- <span
              v-if="comparison.converted !== null"
              class="ml-2"
            >
              <span :class="comparison.converted >= 0 ? 'green--text' : 'red--text'">
                {{ comparison.converted > 0 ? '+' : '' }}{{ comparison.converted }}%
              </span>

              <span class="ml-1 grey--text text--darken-1">
                (D {{ comparison.convertedDirect > 0 ? '+' : '' }}{{ comparison.convertedDirect }}% /
                A {{ comparison.convertedAgency > 0 ? '+' : '' }}{{ comparison.convertedAgency }}%)
              </span>
            </span> -->
          </v-chip>
          
        </span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <!-- Chart Card: New Clients Trend -->
        <v-card
          class="mb-4"
          style="height: 320px;"
        >
          <v-card-title>New Clients Trend</v-card-title>
          <v-card-text style="height: 260px;">
            <canvas id="salesChart" />
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Clients</span>

            <v-btn-toggle
              v-model="clientFilter"
              dense
              mandatory
            >
              <v-btn
                small
                value="all"
              >
                All
              </v-btn>
              <v-btn
                small
                value="direct"
                color="green white--text"
              >
                Direct
              </v-btn>
              <v-btn
                small
                value="agency"
                color="purple white--text"
              >
                Agency
              </v-btn>
              <v-btn
                small
                value="english"
                color="orange white--text"
              >
                English
              </v-btn>
            </v-btn-toggle>
          </v-card-title>

          <v-data-table
            :headers="clientHeaders"
            :items="filteredClients"
            dense
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [itemsPerPage]
            }"
          >
            <!-- format date -->
            <template
              slot="item.first_paid_at"
              slot-scope="props"
            >
              {{ formatDate(props.item.first_paid_at) }}
            </template>

            <template v-slot:[`item.clientName`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.clientId)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.clientName }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>

            <!-- type chip -->
            <template
              slot="item.type"
              slot-scope="props"
            >
              <div class="d-flex align-center">
                <v-chip
                  small
                  class="ml-2"
                  :color="props.item.is_english ? 'orange' : (props.item.agency_id ? 'purple' : 'green')"
                  dark
                >
                  {{
                    props.item.is_english
                      ? 'English'
                      : (props.item.agency_id ? 'Agency' : 'Direct')
                  }}
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card
          class="mb-4 d-flex flex-column"
          style="height: 100%;"
        >
          <v-card-text style="flex: 1;">
            <div
              id="heatmapContainer"
              style="height: 70vh; width: 100%; overflow: auto;"
            >
              <!-- Heatmap will be rendered here -->
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-title>Clients to Contact</v-card-title>

          <v-data-table
            :headers="contactHeaders"
            :items="groupedContactClients"
            dense
            class="elevation-1"
            :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
            item-key="full_name"
          >
            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.clientId)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.full_name }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.salesContact`]="{ item }">
              {{ $store.getters.contactNameById(item.salesContact) }}
            </template>

            <template
              slot="item.nextContact"
              slot-scope="props"
            >
              {{ formatDate(props.item.nextContact) }}
            </template>

            <template
              slot="item.firstContactLead"
              slot-scope="props"
            >
              {{ formatDate(props.item.firstContactLead) }}
            </template>

            <template
              slot="item.firstContactPPC"
              slot-scope="props"
            >
              {{ formatDate(props.item.firstContactPPC) }}
            </template>

            <template
              slot="item.comments"
              slot-scope="{ item }"
            >
              <v-text-field
                v-model="item.sales_comment"
                dense
                hide-details
                placeholder="Add comment..."
                @change="saveSalesComment(item)"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-title>Main Payments Due</v-card-title>

          <v-card-subtitle>
            All clients, with a not fully paid personal application, which consists of the first local resource, starting within 30 days, excluding English courses and Online classes.
          </v-card-subtitle>

          <v-data-table
            :headers="paymentHeaders"
            :items="groupedOpenPayments"
            dense
            class="elevation-1 mt-6"
            :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
            item-key="applicationId"
          >
            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.clientId)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.full_name }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.salesContact`]="{ item }">
              {{ $store.getters.contactNameById(item.salesContact) }}
            </template>

            <template v-slot:[`item.amountOpen`]="{ item }">
              ${{ Number(item.amountOpen).toFixed(2) }}
            </template>

            <template v-slot:[`item.firstResourceDisplay`]="{ item }">
              {{ item.firstResource }}
              <span
                v-if="item.startLocalProgram"
                class="grey--text text--darken-1"
              >
                ({{ formatDate(item.startLocalProgram) }})
              </span>
            </template>

            <template
              slot="item.nextContact"
              slot-scope="props"
            >
              {{ formatDate(props.item.nextContact) }}
            </template>

            <template
              slot="item.comments"
              slot-scope="{ item }"
            >
              <v-text-field
                v-model="item.sales_comment"
                dense
                hide-details
                placeholder="Add comment..."
                @change="saveSalesComment(item)"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>

          <v-card-title>Applications waiting for client</v-card-title>

          <v-data-table
            :headers="applicationHeaders"
            :items="applications"
            dense
            class="elevation-1"
            :search="searchApplicationTable"
            :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
            item-key="id"
          >
            <template v-slot:top>
              <div class="d-flex flex-column my-8">
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchApplicationTable"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ applications.length }` + ' application(s)'"
                      single-line
                      hide-details
                      style="width: 400px"
                      clearable
                    />
                  </v-card>
                </div>
              </div>
            </template>
            <template v-slot:[`item.applied`]="{ item }">
              <span v-html="formattedDate(item.applied, 'dateYearShort')" />
            </template>
            <template v-slot:[`item.start_first_service`]="{ item }">
              <span v-html="formattedDate(item.start_first_service, 'dateYearShort')" />
            </template>
            <template v-slot:[`item.end_last_service`]="{ item }">
              <span v-html="formattedDate(item.end_last_service, 'dateYearShort')" />
            </template>
            <template v-slot:[`item.totalPrice`]="{ item }">
              <span
                v-if="item.totalPrice"
                v-html="'$' + decUtil.format(decUtil.toDec(item.totalPrice))"
              />
            </template>
            <template v-slot:[`item.open`]="{ item }">
              <span
                v-if="item.open && (item.statusAppId ===16)"
                v-html="'<FONT COLOR=grey><strong>$' + decUtil.format(decUtil.toDec(item.open)) + '</strong>'"
              />
              <span
                v-else-if="item.open"
                v-html="'<FONT COLOR=red><strong>$' + decUtil.format(decUtil.toDec(item.open)) + '</strong>'"
              />
              <span
                v-else
                v-html="'<FONT COLOR=green><strong>PAID</strong>'"
              />
            </template>
            <template v-slot:[`item.frozen`]="{ item }">
              <v-icon
                v-if="item.frozen === 1"
                small
                color="ppc_darkgreen"
              >
                $vuetify.icons.icon_mdi_check
              </v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="grey lighten-2"
                    v-bind="attrs"
                    fab
                    x-small
                    :disabled="$store.state.loadingApp > 0"
                    v-on="on"
                  >
                    <v-icon
                      small
                      @click="$store.dispatch('setLoadingApp', 1), showApplication(item.id)"
                    >
                      $vuetify.icons.icon_mdi_pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Edit Application</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>


    </v-tabs-items>
  </v-container>
</template>

<script>
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';
import { Chart, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Tooltip, Filler } from 'chart.js';
import { Legend } from 'chart.js';
import decUtil from '@/utils/decimalUtils';

Chart.register(Legend, Tooltip, Filler);
Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale);

export default {

  mixins: [inputRules, formattedDate],

  data() {
    return {
        decUtil,
        itemsTab: [
          'New Clients Applied', 'Conversion Heatmap', 'Contact Overview', 'Open Payments', 'Open Applications',
        ],

        summary: {
          converted: { total: 0, direct: 0, agency: 0 },
          leads: { total: 0, direct: 0, agency: 0 }
        },
        comparison: {
          converted: null,
          convertedDirect: null,
          convertedAgency: null,
          leads: null,
          leadsDirect: null,
          leadsAgency: null
        },

        clients: [],
        clientFilter: 'all',

        clientHeaders: [
          { text: 'Name', value: 'clientName' },
          { text: 'Source', value: 'type' },
          { text: 'First Paid', value: 'first_paid_at' },
        ],
        monthsBack: 6,

        contactClients: [],
        openPayments: [],
        contactHeaders: [
          { text: 'Week', value: 'week' },
          { text: 'Name', value: 'full_name' },
          { text: 'Sales Contact', value: 'salesContact' },
          { text: 'First Contact Lead', value: 'firstContactLead' },
          { text: 'First Contact PPC', value: 'firstContactPPC' },
          { text: 'Next Contact', value: 'nextContact' },
          { text: 'Comments', value: 'comments' },
        ],
        paymentHeaders: [
          { text: 'Last Payment Date', value: 'lastPaymentDate' },
          { text: 'Name', value: 'full_name' },
          { text: 'Sales Contact', value: 'salesContact' },
          { text: 'First Resource', value: 'firstResourceDisplay' },
          { text: 'Amount Open', value: 'amountOpen' },
          { text: 'Status', value: 'status' },
          { text: 'Comments', value: 'comments' },
        ],
        applicationHeaders: [
            { text: 'Application', align: 'start', value: 'appTitle', width: '200px' },
            { text: 'Payer Name', value: 'payerName', width: '150px' },
            { text: '#Clients', value: 'amountOfClients', width: '80px' },
            { text: 'Applied on', value: 'applied', width: '100px' },
            { text: 'Start', value: 'start_first_service', width: '100px' },
            { text: 'End', value: 'end_last_service', width: '100px' },
            { text: 'Price', value: 'totalPrice' },
            { text: 'Open', value: 'open' },
            { text: 'Comments', value: 'comments', width: '200px' },
            { text: 'Actions', value: 'actions', sortable: false, width: '80px' },
        ],
        applications: [],
        searchApplicationTable: '',
      }
  },
  
  computed: {
    filteredClients() {
      if (this.clientFilter === 'all') return this.clients;

      if (this.clientFilter === 'english') {
        return this.clients.filter(c => c.is_english);
      }

      if (this.clientFilter === 'agency') {
        return this.clients.filter(c => c.agency_id && !c.is_english);
      }

      if (this.clientFilter === 'direct') {
        return this.clients.filter(c => !c.agency_id && !c.is_english);
      }

      return this.clients;
    },
    successMessage () {
      return this.$store.getters.successMessage
    },

    currentMonthOffset: {
      get() {
        return this.dashboardSettings.monthOffset;
      },
      set(val) {
        this.$store.dispatch('setDashboardSettings', { monthOffset: val });
      }
    },

    dashboardSettings() {
      return this.$store.getters.dashboardSettings;
    },

    tab: {
      get() {
        return this.dashboardSettings.tab;
      },
      set(val) {
        this.$store.dispatch('setDashboardSettings', { tab: val });
      }
    },

    monthRange() {
      const start = dayjs()
        .add(this.currentMonthOffset, 'month')
        .startOf('month');

      const end = dayjs()
        .add(this.currentMonthOffset, 'month')
        .endOf('month');

      return {
        start,
        end,
        label: `${start.format('DD MMM')} - ${end.format('DD MMM YYYY')}`
      };
    },

    itemsPerPage () {
        return this.$store.getters.itemsPerPage
    },

    groupedContactClients() {
      if (!this.contactClients || !this.contactClients.length) return [];

      return this.contactClients
        .map(c => {
          const date = dayjs(c.nextContact);

          return {
            ...c,
            week: date.startOf('week').format('DD MMM')
          };
        })
        .sort((a, b) => new Date(a.nextContact) - new Date(b.nextContact));
    },

    groupedOpenPayments() {
      if (!this.openPayments || !this.openPayments.length) return [];

      return this.openPayments
        .map(c => {
          const date = dayjs(c.nextContact);

          return {
            ...c,
            week: date.startOf('week').format('DD MMM')
          };
        })
        .sort((a, b) => new Date(a.nextContact) - new Date(b.nextContact));
    },

  },
  
  watch: {
    successMessage: function () {
      if (this.successMessage !== "") {
        this.alertSuccessMessage = true;
      }
    },

    currentMonthOffset() {
      this.initialize();
    },

    clientFilter() {
      this.$nextTick(() => {
        this.renderChart();
      });
    },

    monthsBack() {
      this.loadGraph();
      if (this.tab === 1) {
        this.loadHeatmap();
      }
    },

    tab(val) {
      if (val === 1) {
        this.loadHeatmap();
      }

      if (val === 0) {
        this.loadGraph();
      }

      if (val === 2) {
        this.loadContactClients();
      }

      if (val === 3) {
        this.loadOpenPayments();
      }

      if (val === 4) {
        this.loadApplications();
      }

    },

  },

  beforeCreate () {
    this.$store.dispatch('setLoadingApp', 1)
  },

  created () {
    dayjs.locale("en");
    this.$store.dispatch('breadcrumbs', ['DashboardSales']);
    this.initialize();
  },

  methods: {

    async loadGraph() {
      await this.$store.dispatch('fetchSalesGraph', this.monthsBack);
      this.$nextTick(() => {
        this.renderChart();
      });
    },

    async initialize () {

      try {
        const start = this.getMonthStart();
        const end = this.getMonthEnd();

        await this.$store.dispatch('fetchSalesSummary', { start, end });

        const clients = await this.$store.dispatch('fetchSalesClients', { start, end });
        if (clients) {
          this.clients = clients;
        }

        if (this.tab === 2) {
          await this.loadContactClients();
        }

        if (this.tab === 3) {
          await this.loadOpenPayments();
        }

        if (this.tab === 4) {
          await this.loadApplications();
        }

        const summary = this.$store.getters.salesSummary;
        if (summary) {
          this.summary = summary;
        }

        // Comparison logic
        const prevStart = dayjs(start).subtract(1, 'month').format('YYYY-MM-DD');
        const prevEnd = dayjs(end).subtract(1, 'month').format('YYYY-MM-DD');

        await this.$store.dispatch('fetchSalesSummary', { start: prevStart, end: prevEnd });
        const prevSummary = JSON.parse(JSON.stringify(this.$store.getters.salesSummary));


        await this.$store.dispatch('fetchSalesSummary', { start, end });

        if (prevSummary) {
          this.comparison.converted = this.calculateGrowth(
            this.summary.converted.total,
            prevSummary.converted.total
          );

          this.comparison.convertedDirect = this.calculateGrowth(
            this.summary.converted.direct,
            prevSummary.converted.direct
          );

          this.comparison.convertedAgency = this.calculateGrowth(
            this.summary.converted.agency,
            prevSummary.converted.agency
          );

          this.comparison.leads = this.calculateGrowth(
            this.summary.leads.total,
            prevSummary.leads.total
          );

          this.comparison.leadsDirect = this.calculateGrowth(
            this.summary.leads.direct,
            prevSummary.leads.direct
          );

          this.comparison.leadsAgency = this.calculateGrowth(
            this.summary.leads.agency,
            prevSummary.leads.agency
          );
        }

        await this.loadGraph();
        this.$nextTick(() => {
          if (this.tab === 0) {
            this.renderChart();
          }
        });

        if (this.tab === 1) {
          await this.loadHeatmap();
          this.monthsBack = 24;
        }

      } catch (err) {
        console.error('DashboardSales load error', err);
      }

      this.$store.dispatch('setLoadingApp', 0)
    },
    
    async loadHeatmap() {
      try {
        await this.$store.dispatch('fetchSalesHeatmap', this.monthsBack);
        this.$nextTick(() => {
          this.renderHeatmap();
        });
      } catch (e) {
        console.error('Heatmap load error', e);
      }
    },


    prevMonth() {
      this.currentMonthOffset--;
    },

    nextMonth() {
      this.currentMonthOffset++;
    },

    goToday() {
      this.currentMonthOffset = 0;
    },

    getMonthStart() {
      return dayjs()
        .add(this.currentMonthOffset, 'month')
        .startOf('month')
        .format('YYYY-MM-DD');
    },

    getMonthEnd() {
      return dayjs()
        .add(this.currentMonthOffset, 'month')
        .endOf('month')
        .format('YYYY-MM-DD');
    },

    renderChart() {
      let data = this.$store.getters.salesGraph;

      if (!data || !data.length) return;

      // filter logic
      let total = [];
      let direct = [];
      let agency = [];
      let englishSchool = [];

      if (this.clientFilter === 'all') {
        direct = data.map(d => Number(d.direct) || 0);
        agency = data.map(d => Number(d.agency) || 0);
        englishSchool = data.map(d => Number(d.english_school) || 0);

        // recompute total so it matches visible segments
        total = data.map(d => Number(d.total) || 0);
      }

      if (this.clientFilter === 'direct') {
        total = data.map(d => d.direct);
        direct = total;
        agency = [];
        englishSchool = [];
      }

      if (this.clientFilter === 'agency') {
        total = data.map(d => d.agency);
        agency = total;
        direct = [];
        englishSchool = [];
      }

      if (this.clientFilter === 'english') {
        total = data.map(d => d.english_school || 0);
        englishSchool = total;
        direct = [];
        agency = [];
      }

      const labels = data.map(d => dayjs(d.month).format('MMM YY'));

      const canvas = document.getElementById('salesChart');
      if (!canvas) return;

      // force canvas resize fix (important when coming from hidden tab)
      canvas.style.display = 'none';
      canvas.offsetHeight; // trigger reflow
      canvas.style.display = '';

      const ctx = canvas.getContext('2d');

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets: [
            // Insert Total line at the top, only when filter is "all"
            ...(this.clientFilter === 'all' ? [{
              label: 'Total',
              data: total,
              borderColor: '#1976D2',
              backgroundColor: 'rgba(25, 118, 210, 0.2)',
              borderWidth: 3,
              tension: 0.3,
              fill: false,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: '#000',
            }] : []),

            ...(this.clientFilter === 'all' || this.clientFilter === 'direct' ? [{
              label: this.clientFilter === 'all' ? 'Direct (not English)' : 'Direct',
              data: direct,
              borderColor: '#2E7D32',
              backgroundColor: 'rgba(46, 125, 50, 0.2)',
              tension: 0.3,
              fill: false,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: '#000',
            }] : []),

            ...(this.clientFilter === 'all' || this.clientFilter === 'agency' ? [{
              label: 'Agency',
              data: agency,
              borderColor: '#8E24AA',
              backgroundColor: 'rgba(142, 36, 170, 0.2)',
              tension: 0.3,
              fill: false,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: '#000',
            }] : []),

            ...(this.clientFilter === 'all' || this.clientFilter === 'english' ? [{
              label: 'English School',
              data: englishSchool,
              borderColor: '#FF9800',
              backgroundColor: 'rgba(255, 152, 0, 0.2)',
              tension: 0.3,
              fill: false,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: '#000',
            }] : [])
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top'
            },
            tooltip: {
              enabled: true,
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y;
                  }
                  return label;
                }
              }
            }
          },
          interaction: {
            mode: 'nearest',
            intersect: false
          },
          scales: {
            y: {
              beginAtZero: true,
              stacked: false,
              ticks: {
                precision: 0
              }
            }
          }
        }
      });
    },

    renderHeatmap() {
      const container = document.getElementById('heatmapContainer');
      if (!container) return;

      const data = this.$store.getters.salesHeatmap;
      if (!data || !data.length) {
        container.innerHTML = '<div style="text-align:center; padding-top: 120px; color: #888;">No data</div>';
        return;
      }

      // Transform data into matrix
      const cohorts = {};
      let maxMonths = 0;

      data.forEach(row => {
        if (!cohorts[row.cohort_month]) {
          cohorts[row.cohort_month] = {};
        }
        cohorts[row.cohort_month][row.months_since] = {
          rate: Number(row.conversion_rate_cumulative),
          conversions: Number(row.conversions_cumulative || 0),
          cohort_size: Number(row.cohort_size || 0)
        };
        if (row.months_since > maxMonths) maxMonths = row.months_since;
      });

      const sortedCohorts = Object.keys(cohorts).sort().reverse();

      // Color scale
      const getColor = (val) => {
        if (val >= 0.5) return '#2E7D32';
        if (val >= 0.3) return '#66BB6A';
        if (val >= 0.1) return '#C8E6C9';
        return '#F5F5F5';
      };

      const getTextColor = (val) => {
        if (val >= 0.3) return '#fff'; // white text on darker greens
        return '#000'; // black text on light background
      };

      let html = '<table style="border-collapse: separate; border-spacing: 0; width: auto; table-layout: fixed; white-space: nowrap; position: relative;">';

      // Header
      html += `<tr>`
      html += `<th style="text-align:left; padding:6px 10px; width: 160px; white-space:nowrap; position: sticky; left: 0; top: 0; z-index: 5; background:#fff;">
          Month (New leads)
        </th>`;
      for (let m = 0; m <= maxMonths; m++) {
        html += `<th style="padding:6px 10px; text-align:center; width: 70px; min-width: 70px; max-width: 70px; position: sticky; top: 0; background:#fff; z-index: 3;">M${m}</th>`;
      }
      html += '</tr>';

      // Rows
      sortedCohorts.forEach(cohort => {
        html += `<tr style="transition: background 0.15s;" 
          onmouseover="this.style.background='#f5f5f5'" 
          onmouseout="this.style.background='transparent'">
          <td style="
            padding:6px 10px; 
            white-space:nowrap; 
            width: 160px;
            position: sticky;
            left: 0;
            background:#fff;
            z-index: 4;
          ">
            ${(() => {
              // cohort size (take from M0 or first available cell)
              const firstCell = cohorts[cohort][0] || Object.values(cohorts[cohort])[0];
              const cohortSize = firstCell ? firstCell.cohort_size : 0;
              return `${cohort} <span style="color:#888;">(${cohortSize})</span>`;
            })()}
          </td>`;

        // cohort size (take from M0 or first available cell)
        const firstCell = cohorts[cohort][0] || Object.values(cohorts[cohort])[0];
        const cohortSize = firstCell ? firstCell.cohort_size : 0;

        // 2) Add ceiling indicator calculation.
        let maxConversion = 0;
        Object.values(cohorts[cohort]).forEach(c => {
          if (c.rate > maxConversion) maxConversion = c.rate;
        });

        for (let m = 0; m <= maxMonths; m++) {
          const cell = cohorts[cohort][m];
          if (cell !== undefined) {
            const val = cell.rate;
            const conversions = cell.conversions;
            let prevConversions = 0;

            // find last available previous month
            for (let i = m - 1; i >= 0; i--) {
              if (cohorts[cohort][i]) {
                prevConversions = cohorts[cohort][i].conversions;
                break;
              }
            }

            const incremental = conversions - prevConversions;
            // 3) Update tooltip to include ceiling.
            html += `<td 
              title="Cohort: ${cohort} | Month: M${m} | Conversion: ${(val * 100).toFixed(1)}% | Converted: ${conversions} (+${incremental}) | Cohort size: ${cohortSize} | Max: ${(maxConversion * 100).toFixed(1)}%"
              style="
                padding:8px 12px; 
                width: 70px;
                min-width: 70px;
                max-width: 70px;
                text-align:center; 
                background:${getColor(val)};
                color:${getTextColor(val)};
                font-weight: 600;
                cursor: pointer;
                position: relative;
                z-index: 1;
              "
            >
              ${(val * 100).toFixed(0)}%
            </td>`;
          } else {
            html += `<td style="background:#fafafa;"></td>`;
          }
        }
        html += '</tr>';
      });

      html += '</table>';

      container.innerHTML = html;
    },

    goClient(id) {
      console.log('goClient', id);
      this.$store.dispatch('setLoadingApp', 1);
      this.$router.push({ name: 'Client', params: { id: id } })
    },

    formatDate(date) {
      return date ? dayjs(date).format('DD MMM YYYY') : '-';
    },

    calculateGrowth(current, previous) {
      if (!previous || previous === 0) return null;
      return Math.round(((current - previous) / previous) * 100);
    },

    async loadContactClients() {
      try {
        const start = this.getMonthStart();
        const end = this.getMonthEnd();

        const clients = await this.$store.dispatch('fetchClientsToContact', { start, end });

        if (clients) {
          this.contactClients = clients;
        }
      } catch (e) {
        console.error('Contact clients load error', e);
      }
    },

    async loadOpenPayments() {
      try {
        const start = this.getMonthStart();
        const end = this.getMonthEnd();

        const payments = await this.$store.dispatch('fetchOpenPayments', { start, end });

        console.log('payments', payments);

        if (payments) {
          this.openPayments = payments;
        }
      } catch (e) {
        console.error('Contact payments load error', e);
      }
    },

    async loadApplications() {
      try {

        this.applications = await this.$store.dispatch('getApplicationsWaitingForClient');

        console.log('applications', this.applications);

        this.checkApplications();

      } catch (e) {
        console.error('Applications load error', e);
      }
    },

    async saveSalesComment(item) {

      try {
        await this.$store.dispatch('updateClientSalesComment', {
          clientId: item.clientId,
          sales_comment: item.sales_comment
        });
      } catch (e) {
        console.error('Save sales comment error', e);
      }
    },

    async showApplication(appId) {
      console.log('showApplication', appId);
      let application = await this.$store.dispatch('getApplicationId', appId);
      await this.$store.dispatch('saveDataForReport', application);
      this.$store.dispatch('showApplication', true);
    },

    checkApplications () {
        if (!this.applications) return;

        this.selectedApplications = [];

        for (const app of this.applications) {

            // determine payer name
            if (app.payerClient !== null) {
                app.payerName = app.payerClientName;
            } else if (app.payerAgency !== null) {
                app.payerName = app.payerAgencyName;
            }

            // normalize numeric values
            if (app.amountPaidApplication == null) app.amountPaidApplication = 0;
            if (app.totalPrice == null) app.totalPrice = 0;

            // normalize comments
            if (app.comments === null) app.comments = '';

            // business rules for selectable
            if (
                app.refund > 0 ||
                app.fixedPrice > 0 ||
                app.discount > 0 ||
                app.extraChargeUSD > 0 ||
                app.comments.trim().length > 0 ||
                app.amountPaidApplication > 0 ||
                app.amountReturnedApplication > 0 ||
                app.statusFixedClient === 8 ||
                app.statusFixedClient === 9
            ) {
                app.isSelectable = false;
            } else {
                app.isSelectable = true;
            }

            // adjust null dates
            if (app.start_first_service === null) app.start_first_service = '';
            if (app.start_last_service === null) app.start_last_service = '';

            // calculate open amount
            app.open = Number(app.totalPrice) - Number(app.amountPaidApplication);
        }
    },

  },
}
</script>

<style>

.months-dropdown-menu {
  z-index: 100 !important;
}

.months-select {
  max-width: 140px;
}

.months-select .v-input__control {
  background: #fafafa;
  border-radius: 8px;
}

.months-select:hover .v-input__control {
  background: #f0f0f0;
}

.months-toggle {
  background: #f5f5f5;
  border-radius: 0px;
  padding: 2px;
  overflow: hidden; /* ensures clean top edge */
}

.months-toggle .v-btn {
  min-width: 48px;
  border-radius: 2px 2px 2px 2px !important; 
  text-transform: none;
  font-weight: 500;
}

.months-toggle .v-btn.v-item--active {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}

</style>